export default {
  props:{
    des: {
      type: String,
      default: "暂无数据"
    }
  },
  data() {
    return {

    }
  }
}



// WEBPACK FOOTER //
// ./src/ni-ui/no-data/data.js